<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <router-link to="/spare-parts" class="btn">Spare Parts</router-link>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="table-responsive">
                    <table id="cart-list" class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 20%;">Product</th>
                                <th style="width: 20%;">Price</th>
                                <th style="width: 10%;">Quantity</th>
                                <th style="width: 25%;">Description</th>
                                <th style="width: 20%;">Subtotal</th>
                                <th style="width: 5%;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in items" :key="row.id">
                                <td>{{ row.item }}</td>
                                <td class="text-center">${{ price_format(row.price) }} USD</td>
                                <td class="text-center"><input type="number" class="form-control" v-model="row.quantity" :value="row.quantity" min="1" @change="update_total(row)"></td>
                                <td>{{ row.description }}</td>
                                <td class="text-right">${{ price_format(row.total) }} USD</td>
                                <td class="text-center"><a href="javascript:void(0);" @click="remove(row.id)"><span class="fa fa-remove"></span></a></td>
                            </tr>
                        </tbody>
                    </table>
                    <template v-if="items.length == 0">
                        <p class="no-results-msg">No items</p>
                    </template>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="offset-md-6 col-md-6">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th colspan="2"><b>Cart Totals</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Subtotal</b></td>
                            <td class="text-right">${{ price_format(subtotal) }} USD</td>
                        </tr>
                        <tr>
                            <td><b>Total</b></td>
                            <td class="text-right">${{ price_format(total) }} USD</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-proceed" :disabled="items.length == 0 || total <= 0" @click="checkout">Proceed to Checkout</button>
            </div>
        </div>
        <checkout-modal :show="showCheckoutModal" @close="closeCheckout" @success="checkoutSuccess"></checkout-modal>
    </div>
</template>
<script>
import CheckoutModal from '../../components/Modals/CheckoutModal.vue'

export default {
    data() {
        return {
            items: [],
            subtotal: 0,
            total: 0,
            showCheckoutModal: false
        }
    },
    components: { CheckoutModal },
    mounted() {
        let cart = localStorage.getItem('cart')
        if(cart) {
            this.items = JSON.parse(cart)
            this.calculate()
        }
    },
    methods: {
        update_total(row) {
            if(row.quantity > 0) {
                let total = parseFloat(row.price) * parseInt(row.quantity)
                row.total = total.toFixed(2)
                localStorage.setItem('cart', JSON.stringify(this.items))
                this.calculate()
            } else {
                this.remove(row.id)
            }
        },
        remove(id) {
            for(let x in this.items) {
                if(this.items[x].id == id) {
                    this.items.splice(x, 1)
                    break
                }
            }
            localStorage.setItem('cart', JSON.stringify(this.items))
            this.calculate()
        },
        calculate() {
            let subtotal = 0
            for(let x in this.items) {
                subtotal = parseFloat(subtotal) + parseFloat(this.items[x].total)
            }
            this.subtotal = subtotal.toFixed(2)
            this.total = this.subtotal
        },
        checkout() {
            this.showCheckoutModal = true
        },
        closeCheckout() {
            this.showCheckoutModal = false
            let cart = localStorage.getItem('cart')
            if(cart) {
                this.items = JSON.parse(cart)
                this.calculate()
            }
        },
        checkoutSuccess() {
            this.showCheckoutModal = false
            this.items = []
            this.subtotal = 0
            this.total = 0
            localStorage.setItem('cart', [])
        },
        price_format(num) {
            return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    }
}
</script>
<style lang="scss" scoped>
#cart-list {
    min-width: 700px;
}
.table {
    th, td {
        font-size: 11px;
        vertical-align: middle;
        font-weight: normal;
        width: auto;
    }
    .form-control {
        font-size: 11px;
        height: 25px;
        width: 60px;
        margin: 0 auto;
    }
}
.btn-proceed {
    background-color: #00a72e;
    color: #ffffff;
    border-radius: 0;
    width: 100%;
    padding: 0.8em;
    &:hover {
        color: #000;
    }
}
.no-results-msg {
    text-align: center;
    padding: 0;
    font-size: 11px;
}
</style>